import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useContext } from "react";
import classnames from "classnames";
import PricingCheck from "/static/svg/pricing-check.svg";
import TooltipComponent from "components/enhancements/tooltip/tooltip-component";
import { DARK_THEME } from "components/enhancements/tooltip/tooltip-constants";
import PricingInfoIcon from "/static/svg/pricing-info-icon.svg";
import productPricingConfig from "segments/desktop/pricing/product-pricing-config";
import { GenericConfigContext } from "/contexts/generic-config-context";
import { TIERS } from "constants/pricing";
import { translateProductKeyFallbackToCore } from "/services/pricing-features-service";
import { StyledProductFeatureValue, StyledProductFeatureName } from "./product-features-table-feature.scss";
import NewPricingCheck from "/static/svg/new-pricing-check.svg";
const isLimitNumeric = (limit)=>{
    return !isNaN(limit);
};
export const ProductFeaturesTableFeature = ({ productName, feature, hideFreeTier, hasFreeTier, isNewPricing, shouldHideBasicTier })=>{
    const { featureName, tierColumnValues } = feature;
    const { translate } = useContext(GenericConfigContext);
    const product = productPricingConfig[productName];
    const productFeatureName = translateProductKeyFallbackToCore({
        productName,
        key: featureName
    });
    const productFeatureDescription = translateProductKeyFallbackToCore({
        productName,
        key: `${featureName}.description`
    });
    const getProductTiers = useCallback(()=>{
        let tiers = [
            ...product.tiers
        ];
        if (!hasFreeTier || hideFreeTier) {
            tiers = tiers.filter((tier)=>tier.name !== TIERS.FREE);
        }
        if (shouldHideBasicTier) {
            tiers = tiers.filter((tier)=>tier.name !== TIERS.BASIC);
        }
        return tiers;
    }, [
        hasFreeTier,
        hideFreeTier,
        product,
        shouldHideBasicTier
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(StyledProductFeatureName, {
                className: "feature-name",
                isNewPricing: isNewPricing,
                children: [
                    productFeatureName,
                    /*#__PURE__*/ _jsxs("div", {
                        className: "icon",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "tooltip",
                                children: /*#__PURE__*/ _jsxs(TooltipComponent, {
                                    theme: DARK_THEME,
                                    className: "floating-tooltip",
                                    children: [
                                        " ",
                                        productFeatureDescription
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(PricingInfoIcon, {})
                        ]
                    })
                ]
            }),
            getProductTiers().map((tier)=>{
                const value = tierColumnValues[tier.name];
                if (value === true) {
                    return /*#__PURE__*/ _jsx(StyledProductFeatureValue, {
                        className: classnames("feature-value", "check-circle"),
                        isNewPricing: isNewPricing,
                        children: isNewPricing ? /*#__PURE__*/ _jsx(NewPricingCheck, {}) : /*#__PURE__*/ _jsx(PricingCheck, {})
                    });
                }
                if (value === undefined || value === null) {
                    return /*#__PURE__*/ _jsx(StyledProductFeatureValue, {
                        className: classnames("feature-value", "check-circle"),
                        isNewPricing: isNewPricing,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "empty-feature-value"
                        })
                    });
                }
                if (typeof value === "object" && value.limit) {
                    return /*#__PURE__*/ _jsxs(StyledProductFeatureValue, {
                        className: "feature-value",
                        isNewPricing: isNewPricing,
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "bold",
                                children: isLimitNumeric(value.limit) ? parseInt(value.limit).toLocaleString() : translate(value.limit)
                            }),
                            " ",
                            translate(value.description)
                        ]
                    });
                }
                return /*#__PURE__*/ _jsx(StyledProductFeatureValue, {
                    className: "feature-value",
                    isNewPricing: isNewPricing,
                    children: translate(value)
                });
            })
        ]
    });
};
